import { Component, OnInit, Inject, ViewChild, TemplateRef } from '@angular/core';
import { DualListComponent } from 'angular-dual-listbox';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { WebStorageService, SESSION_STORAGE } from 'ngx-webstorage-service';
import { Permissions } from '../../../common/model/dictionary/Permissions';
import { RegionalStoreStructureFacade } from '../../../common/facade/RegionalStoreStructureFacade';
import { BsModalService, BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { CatalogDet } from '../../../common/model/CatalogDet';
import { RegionalStoreStructure } from '../../../common/model/RegionalStoreStructure';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { Organization } from '../../../common/model/Organization';
import { Store } from '../../../common/model/Store';
import { ComboMultiSelectComponent } from '../../../containers/combo-multi-select/combo-multi-select.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-zone-admin',
  templateUrl: './zone-admin.component.html',

})
export class ZoneAdminComponent implements OnInit {


  titleManageZones = res.ManageZones;
  lblZones = res.Zones;
  lblOrganizations = res.Organization;
  lblAvailableOrganizations = res.AvailableOrganizations;
  lblRegion = res.Region;
  lblSelectAnOption = res.SelectAnOption;
  lblAddZone = res.AddZone;
  lblZone = res.Zone;
  lblStores = res.Stores;
  lblOrganizationStores = res.OrganizationStores;
  lblEdit = res.Edit;
  lblDelete = res.Delete;
  lblEditZone = res.EditZone;
  lblStoresAvailable = res.StoresAvailable;
  lblAssignedStores = res.AssignedStores;
  lblCancel = res.Cancel;
  lblSave = res.Save;
  lblClose = res.Close;
  lblDeleteZone = res.DeleteZone;
  lblContinue = res.Continue;
  lblSelectOrganization = res.SelectOrganization ;
  lblToShow = res.SelectOrganization;
  lblAllSelected = res.AllSelected;

  isSpanish = true;
  language = 0;

  messagesTable: any = {
    emptyMessage: '',
    totalMessage: ''
  };

  @ViewChild('createModal') public createModal: ModalDirective;
  @ViewChild(ComboMultiSelectComponent) cmbMultiSelect;
  loading = false;
  messageLoader = '';
  modalZone: BsModalRef;
  modalEditZone: BsModalRef;
  modalDetailZone: BsModalRef;
  source: Array<any>;
  confirmed: Array<any>;
  key = 'storeId';
  display = 'storeName';
  cmb_regionId = -1;
  cmb_organization = '-1';
  cmb_organization_addEdit = '-1';
  diDisabled = false;

  // permissions
  permissionsList: any[] = [];
  visibleAdd = false;
  visibleEdit = false;
  zoneSelected = false;
  hiddenEdit = false;
  showCmbOrganizations = -1;
  zoneId = -1;
  flagDelete = true;
  format: any = DualListComponent.DEFAULT_FORMAT;
  // table
  rows: CatalogDet[];
  _filteredDataZoneStores: RegionalStoreStructure[];
  _filteredDataZone: CatalogDet[];
  lsZones: CatalogDet[] = [];
  public lsOrganizations: Organization[] = [];
  public lsOrganizationsAddEdit: Organization[] = [];
  public lsOrganizationSelected: String[] = [];
  store = -1;

  // alert
  alertsFileExcel = [];
  generalAlerts = [];
  lstZoneStores: RegionalStoreStructure[] = [];
  regionSelected = new CatalogDet();
  zoneStoreSelected = new RegionalStoreStructure();
  txt_zone: any;
  config = {
    ignoreBackdropClick: true // si es false se cierra el modal dar clic fuera de el
  };
  _idPositionSelected = 0;

  regStoreRegionalId: any;
  lsZoneStoresDetail: any;
  zoneName = '';
  txtZoneNameAdd = '';
  zoneSelectedId: number;
  alerts: any[] = [];
  accion: number;
  allstores: any[];
  regStoreStrParentId: any;
  lsStores: any;
  template: TemplateRef<any>;
  message: string;
  lsRegions: RegionalStoreStructure[];
  zone: any;
  regionData: any;
  tenantId: any;
  availableOrganizations: Organization[] = [];
  selectedOrganizations: Organization[] = [];
  availableStores: Store[] = [];
  selected: { id: number; name: string; }[];
  stringAvailableOrganizations = '';
  lsOrganizationIds: string[] = [];
  alertsAddEdit: any[] = [];
  flagByOrganization: Boolean = false;

  constructor(
    private modalService: BsModalService,
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private _regionalStoreStructureFacade: RegionalStoreStructureFacade,
    public strings: Strings,
    private _router: Router
    ) {
      this._storage.set('moduleUrl', this._router.url);
    }

  ngOnInit() {
    this.isSpanish = this.strings.getLanguageIsSpanish();
    this.strings.setTenant();
    this.strings.setAvailableOrganizations();
    this.strings.setAvailableStores();
    this.tenantId = this.strings.getTenant();
    this.availableOrganizations = this.strings.getAvailableOrganizations();
    this.availableStores = this.strings.getAvailableStores();

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    if (!this.isSpanish) {
      this.language = 1;
    }

    this.format.add = this.strings.GetText(res.Add);
    this.format.remove = this.strings.GetText(res.Delete);
    this.format.all = this.strings.GetText(res.AllO);
    this.format.none = this.strings.GetText(res.None);
    this.getOrganizations();
    this.getZones();

  }

  getOrganizations() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingOrganizations);

    if (this.tenantId > 0) {
      if ((this.visibleAdd && this.accion == 1) ||  (this.visibleEdit && this.accion == 2)) {
        this.lsOrganizationsAddEdit = this.availableOrganizations.filter(x => x.tenantId == this.tenantId );
      } else {
        this.lsOrganizations = this.availableOrganizations.filter(x => x.tenantId == this.tenantId );
      }

     this.loading = false;
    } else {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.CouldNotGetTenant), 'danger', 'general');
      this.loading = false;
    }
  }

  private zonestores(regStoreRegionalId) {
    this.loading = true;
    this.regStoreRegionalId = regStoreRegionalId;
    this.messageLoader = this.strings.GetText(res.GettingListOfZones);

    if (this.regStoreRegionalId > 0 && this.cmb_organization != '-1') {
      this._regionalStoreStructureFacade.GetRegionalStoreStructureByCatDetRegionStoreTypeIdOrganization(
        this.regStoreRegionalId, this.cmb_organization).subscribe(
        response => {
          this.loading = false;
          if (response.completed) {
            this.lstZoneStores = response.data;
            this._filteredDataZoneStores = this.lstZoneStores;
            this.getRegions();
        } else {
          this.addAlert('<strong>¡Error!</strong> ' + response.message + '', 'danger', 'general');
        }
        }, error => {
          this.loading = false;
          this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.CouldNotGetTheZones), 'danger', 'general');
        }
      );
    } else {
      this.loading = false;
    }
  }

    // añadir alert
  muestraError(message: String): void {
    this.alerts.push({
      type: 'danger',
      msg: message
    });
  }

  private getZones() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingListOfZones);
    this._regionalStoreStructureFacade.GetRegionalStoreStructure(33).subscribe(
      response => {
        if (response.completed) {
          this.loading = false;
          this.lsZones = response.data;
          this.validatePermissions();
        } else {
          this.loading = false;
          this.validatePermissions();
        }
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.CouldNotGetTheZones), 'danger', 'general');
        this.validatePermissions();
      });
  }

  private getRegions() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingRegions);
    this._regionalStoreStructureFacade.GetRegionsRegionalStoreStructureStore(this.regStoreRegionalId).subscribe(
      response => {
        this.loading = false;
        if (response.completed) {
          this.lsRegions = response.data;
        }
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.CouldNotGetTheRegions), 'danger', 'general');
      });
    this.loading = false;
  }

  validatePermissions() {
    this.visibleAdd = false;
    this.visibleEdit = false;
    this.permissionsList = this._storage.get('permissions');
    const pEdit = 'QUANTUM-ADMINISTRAR ' + this.zoneName.toUpperCase().replace(' ', '-').concat('-MODIFICAR');
    const pAdd = 'QUANTUM-ADMINISTRAR ' + this.zoneName.toUpperCase().replace(' ', '-').concat('-CREAR');
    const pZones: CatalogDet[] = [];
    let index = 0;
    this.permissionsList.forEach(element => {
      if (element.name === Permissions.GeneralAccess || element.name === pAdd) {
        this.visibleAdd = true;
      }
      if (element.name === Permissions.GeneralAccess || element.name === pEdit) {
          this.visibleEdit = true;
      }
      if (this.zoneName === '') {
          this.lsZones.forEach(x => {
            if ( element.name === Permissions.GeneralAccess ||
               'QUANTUM-ADMINISTRAR '.concat(x.name.toUpperCase().replace(' ', '-').concat('-CONSULTAR')) === element.name
                ) {
              pZones[index] = x;
              index ++;
            }
          });
        }
      });
    if (this.zoneName === '') {
      this.lsZones = pZones;
    }
  }

  // añadir alert
  addAlert(message: String, type: String, locationMessage: String) {
      this.alerts = [];
      this.alertsAddEdit = [];

      switch (locationMessage) {
        case 'addZone':
          this.alertsAddEdit.push({
            type: type,
            msg: message
          });
          break;
        default:
          this.alerts.push({
            type: type,
            msg: message
          });
      }
  }

  onZoneChange() {
    if (this.zoneId > 0) {
      this.zoneSelected = true;
      this.zoneName = this.lsZones.find(x => x.catDetId == this.zoneId).name.toString();
      this.zonestores(this.zoneId);
      this.validatePermissions();
    } else {
      this.lstZoneStores = [];
      this.zoneSelected = false;
    }
    return;
  }

  onOrganizationChange() {
    this.lsOrganizationIds = [];
    this.selectedOrganizations = this.lsOrganizations;
    this.selectedOrganizations.forEach(element => {
      if (this.cmb_organization == element.organizationId) {
        this.lsOrganizationIds.push(element.organizationId);
      }
    });

    this.zonestores(this.zoneId);
    return;
  }

  // Abrir modal para agregar una zona
  openModalZone(template: TemplateRef<any>, accion: number, id: number, flagByOrganization: boolean = false) {
    this.loading = true;
    this.accion = accion;
    this.alerts = [];
    this.alertsAddEdit = [];
    this.txtZoneNameAdd = '';
    this.lsOrganizationSelected = [];
    this.cmb_regionId = -1;
    if (this.accion !== 1) {
      this.zoneSelectedId = id;
    }
    this.flagByOrganization = flagByOrganization;
    this.getOrganizations();
    if (this.regStoreRegionalId > 0 ) {
      this.getAvailableAssignedStores();
      if (this.accion !== 0) {
          switch (this.accion) {
            case 1:
              this.modalZone = this.modalService.show(
                template,
                Object.assign({}, { class: 'gray modal-lg modal-success' }, this.config)
              );
              break;
            case 2:
              this.modalZone = this.modalService.show(
                template,
                Object.assign({}, { class: 'gray modal-lg modal-info' }, this.config)
              );
              break;
            case 3:
              this.modalZone = this.modalService.show(
                template,
                Object.assign({}, { class: 'gray modal-lg modal-info' }, this.config)
              );
              break;
          }
        } else {
          this.template = template;
        }
      }
    this.loading =  false;
  }

  onClosed(dismissedAlert: AlertComponent, locationMessage: string): void {
    switch (locationMessage) {
      case 'addZone':
        this.alertsAddEdit = this.alertsAddEdit.filter(alert => alert !== dismissedAlert);
        break;
      default:
        this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
    }
  }

  save(newRSS) {
    this.loading = true;
    this._regionalStoreStructureFacade.PostRegionalStoreStructure(newRSS).subscribe(
      result => {
        this.loading = true;
        if (result.completed) {
          this.showSuccessAlert(this.strings.GetText(res.ZoneCreatedSuccessfully));
          this.onZoneChange();
        } else {
          this.showErrorAlert(result.message);
        }
        this.hideModal();
      },
      error => {
        this.loading = false;
        this.handleError(error);
        this.hideModal();
      }
    );
  }

  editZone(newRSS) {
    this.loading = true;
    this._regionalStoreStructureFacade.PutRegionalStoreStructure(newRSS).subscribe(
      result => {
        this.loading = false;
        if (result.completed) {
          this.showSuccessAlert(this.strings.GetText(res.ZoneEditedSuccessfully));
          this.onZoneChange();
        } else {
          this.showErrorAlert(result.message);
        }
        this.hideModal();
      },
      error => {
        this.loading = false;
        this.handleError(error);
        this.hideModal();
      }
    );
  }

  saveZone () {

    const validationResult = this.validateFields();
    let newRSS: any;
    if (validationResult !== 'VALID') {
      this.addAlert(`<strong>¡Error!</strong> ${this.showErrorAlert(validationResult) }`, 'danger', 'addZone');
      return;
    } else {
      switch (this.accion) {
        case 1:
          newRSS = {
            catDetRegionStoreTypeId: this.regStoreRegionalId,
            name: this.txtZoneNameAdd,
            detail: this.confirmed,
            regStoreStrParentId: Number(this.cmb_regionId)
          };
          this.save(newRSS);
          break;
        case 2:
          newRSS = {
            regStoreStrId: this.zoneSelectedId,
            catDetRegionStoreTypeId: this.regStoreRegionalId,
            name: this.txtZoneNameAdd,
            detail: this.confirmed,
            regStoreStrParentId: Number(this.cmb_regionId)
          };
          this.editZone(newRSS);
          break;
      }
    }
  }

  deleteZone() {
    this.loading = true;
    this._regionalStoreStructureFacade.DeleteRegionalStoreStructure(this.zoneSelectedId).subscribe(
      response => {
        this.loading = false;
        if (response.completed) {
          this.addAlert('<strong>' + this.strings.GetText(res.ZoneDeletedSuccessfully) + '</strong>', 'success', 'deleteZone');
          this.onZoneChange();
        }
        this.modalZone.hide();
      }, error => {
        this.loading = false;
        this.addAlert('<strong>' + error + '</strong>', 'danger', 'deleteZone');
        this.modalZone.hide();
        return;
      });
      return;
  }

  onChangeOrganization(selectedOrganizationsCombo: any[]) {
    this.lsOrganizationIds = [];
    this.selectedOrganizations = selectedOrganizationsCombo;
    this.selectedOrganizations.forEach(element => {
      this.lsOrganizationIds.push(element.organizationId);
    });

    if (this.lsOrganizationIds.length > 0) {
      this.getAvailableAssignedStores(false);
    } else {
      this.source = new Array<any>();
      return;
    }
  }

  getAvailableAssignedStores(isFromBtnAddEdit: boolean = true) {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    this.diDisabled = false;
    this.source = new Array<any>();
    this.confirmed = new Array<any>();
    this.allstores = new Array<any>();

    if (this.lsOrganizationIds.length == 0) {
      return;
    }
    switch (this.accion) {
      case 1:
        if (isFromBtnAddEdit) {
          this.lsOrganizationIds = [];
          this.lsOrganizationIds.push(this.cmb_organization);
        }

        let lsOrganizationSelectedAux = []
        this.lsOrganizationIds.forEach(item => {
          var organizationName = this.availableOrganizations.find(x => item == x.organizationId).name
          lsOrganizationSelectedAux.push(organizationName)
        });
        this.lsOrganizationSelected = lsOrganizationSelectedAux;

        this._regionalStoreStructureFacade.GetRegionalStoreStructureStoreAvailableByCatDetRegionStoreTypeIdOrganizations(
          this.regStoreRegionalId, this.lsOrganizationIds)
        .subscribe(
          response => {
            if (response.completed) {
                response.data.storesAvailable.forEach(element => {
                this.source.push(element);
              });
              this.loading = false;
              this.source = response.data.storesAvailable;
            } else {
              this.loading = false;
              this.muestraError('<strong> ' + this.strings.GetText(res.CouldNotGetTheZones) + ', ' + response.message + '<strong>');
              return;
            }
          },
          error => {
            this.loading = false;
            this.muestraError('<strong>' + error + '</strong>');
          }
        );
        break;
      case 2:
        this.txtZoneNameAdd = this.lstZoneStores.find(x => x.regStoreStrId == this.zoneSelectedId).name;
        this.stringAvailableOrganizations = '';

        if (isFromBtnAddEdit) {
          this.availableOrganizations.forEach(item => {
            if (this.stringAvailableOrganizations.trim().length == 0) {
              this.stringAvailableOrganizations = item.organizationId;
            } else {
              this.stringAvailableOrganizations += ',' + item.organizationId;
            }
          });
        }
        else {
          this.lsOrganizationIds.forEach(item => {
            if (this.stringAvailableOrganizations.trim().length == 0) {
              this.stringAvailableOrganizations = item;
            } else {
              this.stringAvailableOrganizations += ',' + item;
            }
          });
        }

        this.loading = true;
        this._regionalStoreStructureFacade.GetRegionalStoreStructureDetGetByRegStoreStrIdOrganizationId
        (this.zoneSelectedId, this.regStoreRegionalId, this.stringAvailableOrganizations.toString()).subscribe(
        response => {
          this.loading = false;
          if (response.completed) {

            if (isFromBtnAddEdit) {
              this.lsOrganizationIds = response.data.stores.map(x => x.organizationId).filter((value, index, self) => self.indexOf(value) === index)
            }

            response.data.storesAvailable.forEach(element => {
              this.source.push(element);
              let store = this.availableStores.find( x => x.storeId == element.storeId);
              if (store != undefined && store != null){
                 if (this.lsOrganizationIds.find (y => y == store.organizationId) != undefined){
                  this.allstores.push(element);
                 }
              }
            });
            
            if (response.data.stores.length > 0) {
              let lsOrganizationSelectedAux = []
              let organizationIdStores = response.data.stores.map(x => x.organizationId).filter((value, index, self) => self.indexOf(value) === index)
              organizationIdStores.forEach(item => {
                var organizationName = this.availableOrganizations.find(x => item == x.organizationId).name
                lsOrganizationSelectedAux.push(organizationName)
              })
              this.lsOrganizationSelected = lsOrganizationSelectedAux
            }

            response.data.stores.forEach(element => {
              this.confirmed.push(element);
              this.allstores.push(element);
            });
            
            this.source = this.allstores;
            this.regionData = response.data.regionData;
            this.cmb_regionId = this.regionData.regionId;
          } else {
            this.muestraError('<strong> ' + this.strings.GetText(res.ThereWasAnErrorGettingTheStores)
             + ', ' + response.message + '<strong>');
            return;
          }
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.muestraError('<strong>' + error + '</strong>');
        }
      );
        break;
      case 3:
          this.zoneSelectedId = this.zoneSelectedId;
          this.txtZoneNameAdd = this.lsZones.find(x => x.catDetId == this.regStoreRegionalId).name;
          this.txtZoneNameAdd = this.txtZoneNameAdd + ' - ' + this.lstZoneStores.find(x => x.regStoreStrId === this.zoneSelectedId).name;

          if (this.flagByOrganization) {
            this._regionalStoreStructureFacade.GetRegionalStoreStructureDetGetByRegStoreStrIdOrganizationId
              (this.zoneSelectedId, this.regStoreRegionalId, this.cmb_organization).subscribe(
              response => {
                this.loading = false;
                if (response.completed) {
                    this.lsStores = response.data.stores;
                } else {
                  this.muestraError('<strong> ' + this.strings.GetText(res.ThereWasAnErrorGettingTheStores) + ', ' + response.message + '<strong>');
                  return;
                }
              },
              error => {
                this.loading = false;
                this.muestraError('<strong>' + error + '</strong>');
              }
            );
          } else {
            this._regionalStoreStructureFacade.GetRegionalStoreStructureDetGetByRegStoreStrId
              (this.zoneSelectedId, this.regStoreRegionalId).subscribe(
              response => {
                this.loading = false;
                if (response.completed) {
                    this.lsStores = response.data.stores;
                } else {
                  this.muestraError('<strong> ' + this.strings.GetText(res.ThereWasAnErrorGettingTheStores) + ', ' + response.message + '<strong>');
                  return;
                }
              },
              error => {
                this.loading = false;
                this.muestraError('<strong>' + error + '</strong>');
              }
            );
          }
      break;
      case 0:
        this._regionalStoreStructureFacade.GetRegionalStoreStructureDetGetByRegStoreStrId
          (this.zoneSelectedId, this.regStoreRegionalId).subscribe(
          response => {
            this.loading = false;
            if (response.completed) {
                this.lsStores = response.data.stores;
                if (this.lsStores.length > 0) {
                  this.message = this.strings.GetText(res.ItIsNotPossibleToDeleteAnAreaWithAssignedStores);
                  this.flagDelete = false;
                } else {
                  this.flagDelete = true;
                  this.message = this.strings.GetText(res.AreYouSureToDeleteTheZone);
                }
                this.modalZone = this.modalService.show(
                  this.template,
                  Object.assign({}, { class: 'gray modal-lg modal-danger' }, this.config)
                );
            } else {
              this.message = '<strong>' + this.strings.GetText(res.ThereWasAnErrorGettingTheStores) + ', ' + response.message + '<strong>';
              return;
            }
          },
          error => {
            this.loading = false;
            this.message = '<strong>' + error + '</strong>';
          }
        );
        break;
      }
      this.loading = false;
  }

  validateFields() {
    if (this.txtZoneNameAdd.toString().trim().length === 0) {
      return 'INVALID_ZONE_NAME';
    }
    if (this.selectedOrganizations.length == 0) {
      return 'ORGANIZATION_NOT_SELECTED';
    }
    if (this.zoneSelectedId <= 0 && this.accion !== 1) {
      return 'ZONE_NOT_SELECTED';
    }
    if (this.regStoreRegionalId <= 0) {
      return 'REGIONAL_STORE_NOT_SELECTED';
    }
    if (Number(this.cmb_regionId) <= 0) {
      return 'REGION_NOT_SELECTED';
    }
    if ((this.accion == 1 ) && this.confirmed.length == 0) {
      return 'STORE_NOT_SELECTED';
    } 
    return 'VALID';
  }

  showErrorAlert(errorCode): string {
    let errorMessage = '';
    switch (errorCode) {
      case 'INVALID_ZONE_NAME':
        errorMessage = this.strings.GetText(res.InvalidZoneName);
        break;
      case 'ZONE_NOT_SELECTED':
        errorMessage = this.strings.GetText(res.CantSave);
        break;
      case 'REGIONAL_STORE_NOT_SELECTED':
        errorMessage = this.strings.GetText(res.CantSave);
        break;
      case 'REGION_NOT_SELECTED':
        errorMessage = this.strings.GetText(res.SelectRegion);
        break;
      case 'ORGANIZATION_NOT_SELECTED':
        errorMessage = this.strings.GetText(res.SelectOrganization);
        break;
      case 'STORE_NOT_SELECTED':
        errorMessage = this.strings.GetText(res.SelectStore);
        break;
      default:
        errorMessage = this.strings.GetText(res.ErrorUnknown);

    }
    return errorMessage;
  }

  handleError(error) {
    this.addAlert(`<strong>¡Error!</strong> ${error}`, 'danger', 'addZone');
  }
  
  showSuccessAlert(message) {
    this.addAlert(`<strong>${message}</strong>`, 'success', 'general');
  }
    
  hideModal() {
    this.modalZone.hide();
  }

  showCmbOrganization() {
    this.hiddenEdit = !this.hiddenEdit;
    return;
  }
  
}
